/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CircleDollarRegular from './circle-dollar-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CircleDollarRegular {...validProps} />;
}
SvgComponent.iconName = 'circleDollarRegular';

export const CircleDollarRegularIcon = svgIconWrapper(SvgComponent);
